import React, { Component } from "react";
import { withStyles, styled } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { Grid, TextField, Snackbar } from "@material-ui/core";
import { withRouter } from "react-router-dom";
import { Table, DatePicker, Button, Input, Select, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { CloseOutlined, DeleteOutlined } from '@ant-design/icons'
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
const { Option } = Select;

import {
  getInnovateList,
} from "../../actions/subscribe";

const styles = () => {
  return {
    root: {
      width: "100%",
    },
    search: {
      width: "100%",
      height: "61px",
      padding: "18px 24px",
      flexFlow: "column",
      background: "#fff",
    },
    line: {
      height: "25px",
      fontSize: "14px",
      color: "#000",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-between",
    },
    title: {
      marginRight: "10px",
      fontSize: "18px",
      fontWeight: "bold",
      color: "#5F6876",
    },
    btn: {
      width: "70px",
      height: "40px",
      background: "#3276C3",
      borderRadius: "0 !important",
    },
    container: {
      paddingTop: '20px'
    },
    tabBox: {
      height: "40px",
      "& .ant-tabs-nav": {
        marginBottom: "0 !important",
      },
      "& .ant-tabs-content-holder": {
        height: "0 !important",
      },
      "& .ant-tabs-tab-btn": {
        fontSize: "16px !important",
        fontWeight: "bold",
      },
    },
    tabContainer: {
      flex: "1",
      width: "100%",
      height: "1px",
      padding: "12px",
      background: "#fff",
      overflow: "hidden",
      boxShadow: "0 0 30px 10px rgba(0, 0, 0, .05)",
    },
    dateFilter: {
      width: "236px",
      padding: "8px",
    },
    defaultFilter: {
      width: "196px",
      padding: "8px",
    },
    btnLine: {
      marginTop: "8px",
      display: "flex",
      justifyContent: "space-between",
    },
    select: {
      width: "100%",
    },
    tableContainer: {
      width: "100%",
      "& .ant-table-cell-row-hover": {
        background: "#f0fbff !important",
      },
      "& td.ant-table-column-sort": {
        background: "#f0fbff !important",
      },
      "& .ant-table-cell": {
        wordBreak: "break-all !important",
      },
    },
    bold: {
      fontWeight: "bold",
    },
  };
};

class Innovate extends Component {
  constructor(props) {
    super(props);
  }

  state = {
    loading: true,
    filteredInfo: null,
    filterForm: {},
    filterDropdownVisible: false,
    columns: [],
    data: [],
    tabIndex: 0,
    updateTime: '',
    searchHistoryList: [],
    form: {},
    defaultForm: { // 默认值
      KeyWord: "",
      publicityNumber: "",
      productName: "",
      category: "",
      acceptanceNumber: "",
      applicantName: "",
      releaseDate: [],
    },
    labelObj: { // 筛选项key - label对应关系
      KeyWord: '关键词',
      publicityNumber: '公示号',
      productName: '产品名称',
      category: '分类',
      acceptanceNumber: '受理号',
      applicantName: '代理人',
      releaseDate: '公示时间',
    },
    labelListObj: { 
    },
    selectKeys: [],
    dataType: [],
    sourceList: [],
    defaultOrder: "descend",
    isPayList: [
      {
        ID: "是",
        Name: "是",
      },
      {
        ID: "否",
        Name: "否",
      },
    ],
    page: {
      page: 1,
      pageSize: 10,
    },
    total: 0,
    scrollObj: {
      y: 600,
    },
    sortObj: {
      SortCriteria: "TrainingTimeKS",
      SortCriteriaMode: "Desc",
    },
    paginationObj: {
      showSizeChanger: true,
      allTotal: 0,
      total: 0,
      showTotal: (total, range) => {
        return (
          "当前已筛选出【" +
          this.state.paginationObj.total +
          "】条，总数据量【" +
          this.state.paginationObj.allTotal +
          "】条"
        );
      },
      onChange: (page, pageSize) => {
        this.pageChange(page, pageSize);
      },
    },
  };

  componentDidMount() {

    let search = decodeURI(this.props.location.search)
    let params = search.substring(1).split('&')
    let obj = params.find(v => {
      return v.indexOf('keyword=') == 0
    })
    if (obj) {
      let urlKeyword = obj.split('=')[1]
      this.setState({
        form: {
          ...this.state.form,
          KeyWord: urlKeyword,
        },
      }, () => this.initData())
    } else {
      this.initData()
    }
   
    let date = new Date()
    let year = date.getFullYear()
    let month = date.getMonth() + 1
    let day = date.getDate()
    let today = `${year}-${month < 10 ? `0${month}` : month}-${day < 10 ? `0${day}` : day}`
    this.setState({
      updateTime: today
    })
  }

  resetForm = () => {
    this.setState({
      form: {
        KeyWord: "",
        SourceOrganization: undefined,
        TrainingContent: "",
        TrainingTime: [],
        HowToAttend: "",
        WhetherToPay: undefined,
        WebUrl: "",
        Remarks: "",
      }
    })
  }

  clearHistory = () => {
    this.resetForm()
    this.setState({
      searchHistoryList: []
    }, () => this.initData())
  }

  removeSearchItem = (data, i) => {
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    form[data.key] = this.state.defaultForm[data.key]
    list.splice(i, 1)
    this.setState({
      form: form,
      searchHistoryList: list
    }, () => this.initData())
  }

  searchForm = () => {
    this.initData()
    // 添加历史搜索记录
    let form = {
      ...this.state.form
    }
    let list = [].concat(this.state.searchHistoryList)
    for (let key in form) {
      let index = list.findIndex(v => {
        return v.key == key
      })
      if (form[key] && form[key].length > 0) {
        let showValue = form[key]
        let label = ''
        if (key == 'releaseDate') {
          showValue = `${showValue[0].format("YYYY-MM-DD")} - ${showValue[1].format("YYYY-MM-DD")}`
        }
        if (this.state.selectKeys.indexOf(key) > -1) {
          label = this.state[this.state.labelListObj[key]].find(v => {
            return v.ID == showValue
          }).Name
        }
        if (index === -1) {
          let param = {
            label: this.state.labelObj[key],
            value: label || showValue,
            key: key
          } 
          list.push(param)
        } else {
          let itemIndex = list.findIndex(v => {
            return v.key == key
          })
          list[itemIndex].value = label || showValue
        }
      } else {
        if (index > -1) {
          list.splice(index, 1)
        }
      }
    }
    this.setState({
      searchHistoryList: list
    })
  }

  onChangeForm = (value, key) => {
    let form = {
      ...this.state.form
    }
    form[key] = value
    this.setState({
      form: form
    })
  }

  initData = () => {
    let releaseDate = this.state.form.releaseDate
    let param = Object.assign(
      {},
      this.state.form,
      this.state.page,
    );
    if (releaseDate && releaseDate.length > 0) {
      param.startReleaseDate = releaseDate[0].format("YYYY-MM-DD")
      param.endReleaseDate = releaseDate[1].format("YYYY-MM-DD")
    }
    delete(param.releaseDate)
    getInnovateList(param).then((res) => {
      if (!res.Error) {
        let newPaginationObj = this.state.paginationObj;
        newPaginationObj.total = res.DataNumber;
        newPaginationObj.allTotal = res.UnfilteredAllDataNumber;
        this.setState(
          {
            data: res.DataList,
            paginationObj: newPaginationObj,
            loading: false,
          },
          () => {
            this.getColumns();
          }
        );
      } else {
        this.setState({
          loading: false,
          data: [],
        });
      }
    });
  };

  getColumns = () => {
    let classes = this.props.classes;

    let columns = [
      {
        title: "公示号",
        dataIndex: "publicityNumber",
        width: 140,
        key: "publicityNumber",
      },
      {
        title: "产品名称",
        width: 320,
        dataIndex: "productName",
        key: "productName",
      },
      {
        title: "分类",
        dataIndex: "category",
        key: "category",
        width: 140,
      },
      {
        title: "受理号",
        dataIndex: "acceptanceNumber",
        key: "acceptanceNumber",
        width: 140,
      },
      {
        title: "代理人",
        dataIndex: "applicantName",
        key: "applicantName",
        width: 140,
      },
      {
        title: "公示时间",
        dataIndex: "releaseDate",
        width: 160,
        key: "releaseDate",
        render: (releaseDate) => (
          <span>{releaseDate ? releaseDate.substring(0, 10) : ''}</span>
        ),
      },
      {
        title: "备注",
        width: 220,
        dataIndex: "Remarks",
        key: "Remarks",
      },
    ];

    this.setState({
      columns: columns,
    });
  };

  handleChange = (pagination, filters, sorter) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleSort = () => {};

  clearFilters = () => {
    this.setState({ filteredInfo: null });
  };

  clearAll = () => {
    this.setState(
      {
        filteredInfo: null,
        page: {
          page: 1,
          pageSize: 10,
        },
        form: {},
        loading: true,
      },
      () => {
        this.getColumns();
        this.initData();
      }
    );
  };

  handleReset = (clearFilters) => {
    clearFilters();
  };



  pageChange = (page, pageSize) => {
    if (
      page == this.state.page.page &&
      pageSize == this.state.page.pageSize
    ) {
      return;
    }
    this.setState(
      {
        page: {
          page: page,
          pageSize: pageSize,
        },
        loading: true,
      },
      () => this.initData()
    );
  };

  render() {
    const classes = this.props.classes;

    return (
      <div className="common-page">
        <div className="common-left-search">
          <div className="left-search-title">
            <span className="search-title">关键词搜索</span>
            
          </div>
          <div className="search-form">
            <div className="form-item">
              <div className="form-label">关键词</div>
              <Input  value={this.state.form.KeyWord}
                allowClear
                onChange={(e) => this.onChangeForm(e.target.value, 'KeyWord')} 
                placeholder="请输入关键词"/>
            </div>
            <div className="form-item">
              <div className="form-label">公示号</div>
              <Input  value={this.state.form.publicityNumber}
                onChange={(e) => this.onChangeForm(e.target.value, 'publicityNumber')} 
                placeholder="请输入公示号"/>
            </div>

            <div className="form-item">
              <div className="form-label">产品名称</div>
              <Input  value={this.state.form.productName}
                onChange={(e) => this.onChangeForm(e.target.value, 'productName')} 
                placeholder="请输入产品名称"/>
            </div>
            <div className="form-item">
              <div className="form-label">分类</div>
              <Input  value={this.state.form.category}
                onChange={(e) => this.onChangeForm(e.target.value, 'category')} 
                placeholder="请输入分类"/>
            </div>
            <div className="form-item">
              <div className="form-label">受理号</div>
              <Input  value={this.state.form.acceptanceNumber}
                onChange={(e) => this.onChangeForm(e.target.value, 'acceptanceNumber')} 
                placeholder="请输入受理号"/>
            </div>
            <div className="form-item">
              <div className="form-label">代理人</div>
              <Input  value={this.state.form.applicantName}
                onChange={(e) => this.onChangeForm(e.target.value, 'applicantName')} 
                placeholder="请输入代理人"/>
            </div>
            <div className="form-item">
              <div className="form-label">公示时间</div>
              <RangePicker
                value={this.state.form.releaseDate}
                onChange={(value) => this.onChangeForm(value, 'releaseDate')}
              />
            </div>
           
            

          </div>

          <div className="search-bottom-btns">
            <Button className="default-btn" onClick={this.resetForm}>重置</Button>
            <Button className="primary-btn" onClick={this.searchForm}>搜索</Button>
          </div>
        </div>

        <div className="common-main">
          <div className="common-main-search">
            <div className="main-title">
              <div className="title-top">
                <div>
                  <span className="page-title">创新与优先</span>
                  <span className="page-count">{this.state.paginationObj.total}条</span>
                </div>
                <span >数据更新至：{this.state.updateTime}</span>
              </div>
            </div>
            {
              this.state.searchHistoryList.length > 0 &&
              <div className="search-history">
                {
                  this.state.searchHistoryList.map((item, i) => (
                    <div className="history-item" key={i}>
                      <span>{item.label}：</span>
                      <span className="history-value">{item.value}</span>
                      <CloseOutlined className="clear-icon" onClick={() => this.removeSearchItem(item, i)}/>
                    </div>
                  ))
                }
                <div className="hitstory-btn" onClick={this.clearHistory}>
                  <DeleteOutlined className="btn-icon"/>
                  清空
                </div>
              </div>
            }
          </div>
          <div className="common-main-container">
            <Grid container className={classes.container} id="tableContainer">
              <Table
                className={classes.tableContainer}
                columns={this.state.columns}
                loading={this.state.loading}
                dataSource={this.state.data}
                onChange={this.handleChange}
                pagination={this.state.paginationObj}
                bordered
              />
            </Grid>
          </div>
        </div>
      </div>
    );
  }
}

export default withStyles(styles)(withRouter(Innovate));
